import React, { useState, useContext } from 'react';
import { MapPin, Eye, Edit2, Trash2, Image as ImageIcon } from 'lucide-react';
import AppContext from '../../../context/AppContext';

const DestinationCard = ({ destination, onEdit, onDelete, onViewDetails, onStatusToggle }) => {

  const { imageBaseUrl } = useContext(AppContext);
  const [imageError, setImageError] = useState(false);


  const resolveImagePath = (path) => {
    if (!path) return null;
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    return `${imageBaseUrl}/${path}`;
  };

  const primaryGalleryImage = destination.jjdestinationgallerys?.[0]?.des_gallery;
  const imageUrl = resolveImagePath(primaryGalleryImage);
  const showPlaceholder = !imageUrl || imageError;

  const name        = destination.destination_name;
  const district     = destination.district;
  const province     = destination.province;
  const season       = destination.best_season;
  const duration      = destination.recommended_duration;
  const climate      = destination.climate;
  const desc         = destination.description;
  const minBudget     = destination.min_budget;
  const maxBudget     = destination.max_budget;
  const spotsCount   = (destination.jjdestinationspots ?? []).length;
  const photosCount  = (destination.jjdestinationgallerys ?? []).length;

  const budgetStr = minBudget && maxBudget
    ? `${Number(minBudget).toLocaleString()} – ${Number(maxBudget).toLocaleString()}`
    : null;

  const status   = destination.status || 'Active';
  const isActive = status === 'Active';

  return (
    <div className="dc-card">

      <div className="dc-img-wrap">
        {!showPlaceholder ? (
          <img
            src={imageUrl}
            alt={name}
            className="dc-img"
            loading="lazy"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="dc-img-placeholder">
            <ImageIcon size={40} className="dc-placeholder-icon" />
            <span className="dc-placeholder-text">No Image</span>
          </div>
        )}

        <div className="dc-img-overlay">
          <h5 className="dc-overlay-name" title={name}>{name}</h5>
          <div className="dc-overlay-loc">
            <MapPin size={12} />
            <span>{district}, {province}</span>
          </div>
        </div>

        <span className={`dc-badge dc-badge--status dc-badge--${isActive ? 'active' : 'inactive'}`}>
          <span className="dc-dot" />
          {status}
        </span>

        {climate && (
          <span className="dc-badge dc-badge--climate">{climate}</span>
        )}
      </div>
      <div className="dc-body">
        <div className="dc-stats">
          <div className="dc-stat">
            <span className="dc-stat-label">Best Season</span>
            <span className="dc-stat-value">{season || 'N/A'}</span>
          </div>
          <div className="dc-stat">
            <span className="dc-stat-label">Duration</span>
            <span className="dc-stat-value">{duration ? `${duration} days` : 'N/A'}</span>
          </div>
        </div>

        {desc ? (
          <p className="dc-desc">
            {desc.length > 90 ? desc.substring(0, 90) + '…' : desc}
          </p>
        ) : null}

        <div className="dc-chips">
          <span className="dc-chip dc-chip--green">
            <MapPin size={11} />
            {spotsCount} spot{spotsCount !== 1 ? 's' : ''}
          </span>
          <span className="dc-chip dc-chip--blue">
            <Eye size={11} />
            {photosCount} photo{photosCount !== 1 ? 's' : ''}
          </span>
          {budgetStr && (
            <span className="dc-chip dc-chip--amber">
              PKR {budgetStr}
            </span>
          )}
        </div>
      </div>

      <div className="dc-footer">
        <div className="dc-footer-actions">
          <button
            className="dc-action-btn dc-action-btn--view"
            onClick={() => onViewDetails(destination)}
            title="View details"
          >
            <Eye size={15} /><span>View</span>
          </button>
          <button
            className="dc-action-btn dc-action-btn--edit"
            onClick={() => onEdit(destination)}
            title="Edit"
          >
            <Edit2 size={15} /><span>Edit</span>
          </button>
          <button
            className="dc-action-btn dc-action-btn--delete"
            onClick={() => onDelete(destination.id, name)}
            title="Delete"
          >
            <Trash2 size={15} /><span>Delete</span>
          </button>
        </div>
        <button
          className={`dc-status-toggle dc-status-toggle--${isActive ? 'deactivate' : 'activate'}`}
          onClick={() => onStatusToggle(destination.id, status)}
        >
          {isActive ? 'Deactivate' : 'Activate'}
        </button>
      </div>

    </div>
  );
};

export default DestinationCard;